import { IMenuItem } from "@aecom/core";

// application table
export const rfiAppId = "8a011299-0baf-11ea-917a-027e1b1809fa";

/* old one */
export const queensGarage = "037c7f4d-0562-46b1-ac09-d4c35c0d9705";

export const productName = "RFI";

export const productSubtitle = "";

export const productMaintitle = "NYC BBJ PROGRAM";

export const appitems: IMenuItem[] = [
  {
    name: "Support",
    icon: "icon-action_app_support",
    id: "support",
    externalurl:
      "https://apps.powerapps.com/play/c04c6371-a3a6-4b25-a94c-9fe7fd35a16b?tenantId=bfb413d6-9a23-4cd3-a58d-e141aaf2948a",
  },
  {
    name: "Onboarding",
    icon: "bbj_onboarding_icon",
    id: "onboarding",
    externalurl:
      "https://apps.powerapps.com/play/e7e45d8e-50c2-4d1b-bafb-dd3cdafd5b66?tenantId=bfb413d6-9a23-4cd3-a58d-e141aaf2948a",
  },
];

export const UniformatSpecType = "Uniformat";
export const MasterSpecType = "Master";
export const DesignClassificationId = "e549a260-e02a-11eb-a7b4-ace2d34b68ef";
export const PerformanceContractRequirementId = "b6b35939-da44-4be1-80ec-f80e0f7b3f53";